<template>
    <div class="container-fluid" :style="(opciones.conEstilosDefault.mostrar) ? opciones.conEstilosDefault.css : ''">
        <div id="contenedor-materiales">
            <div id="titulo">
                <h4>Material</h4>
            </div>
            <CNoSeEncontraronResultados v-if="!this.campoRequeridoEsValido(materiales)" :opciones="{ tituloBusqueda: 'Búsqueda en materiales', NombreSeccion: 'Materiales' }"></CNoSeEncontraronResultados>
            <div v-if="this.campoRequeridoEsValido(materiales)" id="materiales" class="form-inline">
                <div v-for="(material,index) in materiales" :key="'fdoc' + index" class="material form-inline" @click="accesoAContenido({ rutaDeDescarga: material.esDescarga, ruta: material.RutaDeAcceso })">
                    <h6><i :class="material.icono"></i>&nbsp;&nbsp;{{ material.nombre }}</h6>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/../static/js/api'
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'

export default {
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        materiales: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                conEstilosDefault: { mostrar: false, css: '' }
            })
        },
    },
    components: {
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    methods: {
        accesoAContenido: function({ rutaDeDescarga, ruta }) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.target = (!rutaDeDescarga) ? "_blank" : '';
            a.href = (rutaDeDescarga) ? `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ ruta }` : ruta;
            a.click();
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    }
}
</script>
<style scoped>
#contenedor-materiales {
    border: 1px solid #A4A0A0;
    border-radius: 4px;
}

#titulo {
    background-color: rgb(59, 59, 59);
    color: white;
    /* background-color: #CDCCCC;    
    color: black; */
    padding: 0.3em 2em 0.1em 2em;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

#titulo h4 {
    font-size: 2em;
    font-weight: bold;
}

#materiales {
    padding: 3.5vmin 2.5vmin 3.5vmin 2.5vmin;
    background-color: rgb(224, 224, 224);
}

.material {
    border: 1px solid black;
    width: max-content;
    background-color: #EDE7E7;
    color: black;
    margin-right: 1em;
    border-radius: 6px;
    padding: 0.6em 1em 0.3em 1em;
    cursor: pointer;
}

.material:hover, .material:focus {
    background-color: black;
    color: white;
    border: none;
}

.material i {
    font-size: 3vmin;
}

.material h6 {
    font-size: 2.5vmin;
    font-weight: bold;
}

@media screen and (max-width: 600px) {
    #materiales {
        flex-direction: column;
    }

    #materiales div {
        margin-bottom: 0.5em;
    }

    .material {
        align-self: flex-start;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CContenedorMaterial.vue